import { useQuery } from '@tanstack/react-query';
import { APIClinicBalance } from 'lib/api/firebase/apis/api-clinic-balance';
import { AssessmentType } from 'lib/documents/patient-assessment/patient-assessment';
import { useClinicianContext } from 'lib/hooks/use-resolveCurrentClinicInfo';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useClinicAssessmentBalance(assessmentType: AssessmentType | undefined) {
  const { currentClinic } = useClinicianContext();
  const clinicId = currentClinic;
  return useQuery({
    queryKey: queryKeyFactory.clinic.assessmentBalance(
      clinicId,
      assessmentType as AssessmentType
    ),
    queryFn: () =>
      APIClinicBalance.getBalance({ clinicId, type: assessmentType as AssessmentType }),
    enabled: !!clinicId && assessmentType !== undefined
  });
}
export function useAggregateDataQuery(
  clinicId: string,
  period: 'day' | 'week' | 'month' = 'day'
) {
  return useQuery({
    queryKey: queryKeyFactory.clinic.balance.aggregateHistory(clinicId),
    queryFn: () =>
      APIClinicBalance.viewAggregatedUsageHistory({ clinicId, period })
  });
}
